function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6254 7.40625H4.48322L9.9551 2.65625C10.0426 2.57969 9.98947 2.4375 9.87385 2.4375H8.49104C8.4301 2.4375 8.37229 2.45937 8.32697 2.49844L2.42229 7.62187C2.36821 7.66875 2.32483 7.72671 2.29511 7.79181C2.26538 7.85692 2.25 7.92765 2.25 7.99922C2.25 8.07079 2.26538 8.14152 2.29511 8.20663C2.32483 8.27173 2.36821 8.32968 2.42229 8.37656L8.36135 13.5312C8.38479 13.5516 8.41291 13.5625 8.4426 13.5625H9.87229C9.98791 13.5625 10.041 13.4187 9.95354 13.3437L4.48322 8.59375H13.6254C13.6942 8.59375 13.7504 8.5375 13.7504 8.46875V7.53125C13.7504 7.4625 13.6942 7.40625 13.6254 7.40625Z",
  fill: "currentColor"
});

var SvgLeftArrow = function SvgLeftArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentCollor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/left-arrow.4a275b72.svg";
export { ForwardRef as ReactComponent };